export default "__VITE_ASSET__RFeWvO05__"